import { OnInit } from '@angular/core';
import { Component } from '@angular/core';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  standalone: false
})
export class MainComponent implements OnInit {

  constructor(
  ) { }

  async ngOnInit() {
  }
}
